const crudReducer = function reducerFactory(actionTypes) {
  return function crudReducerFunc(state = {}, action) {
    switch (action.type) {
      case actionTypes.FETCH_ALL_PENDING:
        return {
          ...state,
          dataAll: null,
          isFetchAllError: false,
          isFetchAllPending: true,
          isFetchAllSuccess: false,
        };
      case actionTypes.FETCH_ALL_SUCCESS:
        return {
          ...state,
          dataAll: action.data,
          isFetchAllError: false,
          isFetchAllPending: false,
          isFetchAllSuccess: true,
        };
      case actionTypes.FETCH_ALL_ERROR:
        return {
          ...state,
          dataAll: {},
          isFetchAllPending: false,
          isFetchAllError: true,
          isFetchAllSuccess: false,
          message: action.message,
        };
      case actionTypes.FETCH_PENDING:
        return {
          ...state,
          data: null,
          isFetchError: false,
          isFetchPending: true,
          isFetchSuccess: false,
        };
      case actionTypes.FETCH_SUCCESS:
        return {
          ...state,
          data: action.data,
          isFetchError: false,
          isFetchPending: false,
          isFetchSuccess: true,
        };
      case actionTypes.FETCH_ERROR:
        return {
          ...state,
          data: {},
          isFetchError: true,
          isFetchPending: false,
          isFetchSuccess: false,
          message: action.message,
        };

      case actionTypes.FETCH_HISTORY_PENDING:
        return {
          ...state,
          dataHistory: null,
          isFetchHistoryError: false,
          isFetchHistoryPending: true,
          isFetchHistorySuccess: false,
        };
      case actionTypes.FETCH_HISTORY_SUCCESS:
        return {
          ...state,
          dataHistory: action.data,
          isFetchHistoryError: false,
          isFetchHistoryPending: false,
          isFetchHistorySuccess: true,
        };
      case actionTypes.FETCH_HISTORY_ERROR:
        return {
          ...state,
          dataHistory: {},
          isFetchHistoryError: true,
          isFetchHistoryPending: false,
          isFetchHistorySuccess: false,
          message: action.message,
        };
      case actionTypes.EDIT_PENDING:
        return {
          ...state,
          isEdit: true,
        };
      case actionTypes.EDIT_DONE:
        return {
          ...state,
          isEdit: false,
        };
      case actionTypes.CREATE_PENDING:
        return {
          ...state,
          isCreate: true,
        };
      case actionTypes.CREATE_DONE:
        return {
          ...state,
          isCreate: false,
        };
      case actionTypes.SET_FILTER:
        return {
          ...state,
          filter: action.data,
        };
      default:
        return state;
    }
  };
};

const readReducer = function reducerFactory(actionTypes) {
  return function readReducerFunc(state = {}, action) {
    switch (action.type) {
      case actionTypes.FETCH_ALL_PENDING:
        return {
          ...state,
          dataAll: null,
          isFetchAllError: false,
          isFetchAllPending: true,
          isFetchAllSuccess: false,
        };
      case actionTypes.FETCH_ALL_SUCCESS:
        return {
          ...state,
          dataAll: action.data,
          isFetchAllError: false,
          isFetchAllPending: false,
          isFetchAllSuccess: true,
        };
      case actionTypes.FETCH_ALL_ERROR:
        return {
          ...state,
          dataAll: [],
          isFetchAllPending: false,
          isFetchAllError: true,
          isFetchAllSuccess: false,
          message: action.message,
        };
      case actionTypes.FETCH_PENDING:
        return {
          ...state,
          data: null,
          isFetchError: false,
          isFetchPending: true,
          isFetchSuccess: false,
        };
      case actionTypes.FETCH_SUCCESS:
        return {
          ...state,
          data: action.data,
          isFetchError: false,
          isFetchPending: false,
          isFetchSuccess: true,
        };
      case actionTypes.FETCH_ERROR:
        return {
          ...state,
          data: {},
          isFetchError: true,
          isFetchPending: false,
          isFetchSuccess: false,
          message: action.message,
        };

      case actionTypes.FETCH_HISTORY_PENDING:
        return {
          ...state,
          dataHistory: null,
          isFetchHistoryError: false,
          isFetchHistoryPending: true,
          isFetchHistorySuccess: false,
        };
      case actionTypes.FETCH_HISTORY_SUCCESS:
        return {
          ...state,
          dataHistory: action.data,
          isFetchHistoryError: false,
          isFetchHistoryPending: false,
          isFetchHistorySuccess: true,
        };
      case actionTypes.FETCH_HISTORY_ERROR:
        return {
          ...state,
          dataHistory: {},
          isFetchHistoryError: true,
          isFetchHistoryPending: false,
          isFetchHistorySuccess: false,
          message: action.message,
        };
      case actionTypes.SET_FILTER:
        return {
          ...state,
          filter: action.data,
        };
      default:
        return state;
    }
  };
};

export const reducerFactory = { crudReducer, readReducer };
